import { render, staticRenderFns } from "./ProductsWithNoOrders.vue?vue&type=template&id=3d5e111a&scoped=true"
import script from "./ProductsWithNoOrders.vue?vue&type=script&lang=js"
export * from "./ProductsWithNoOrders.vue?vue&type=script&lang=js"
import style0 from "./ProductsWithNoOrders.vue?vue&type=style&index=0&id=3d5e111a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5e111a",
  null
  
)

export default component.exports